import type { Schema } from '@atlaskit/editor-prosemirror/model';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

/*
 * Returns true if the schema supports nesting an expand inside a panel (panel_c1 variant),
 * AND the `platform_editor_nest_expand_in_panel` experiment is enabled.
 *
 * ```typescript
 * const supportsExpandInPanel = isPanelNestingExpandSupported(state.schema);
 * ```
 */
export const isPanelNestingExpandSupported = (schema: Schema): boolean => {
	const { expand, panel_c1 } = schema.nodes;

	if (!expand || !panel_c1) {
		return false;
	}

	// Confirm the PM schema actually allows expand inside panel_c1
	const panelC1CanContainExpand = panel_c1.contentMatch.matchType(expand)?.validEnd === true;

	return (
		panelC1CanContainExpand &&
		expValEquals('platform_editor_nest_expand_in_panel', 'isEnabled', true)
	);
};
